export const generalNumbersFormatter = (value) =>
  value ? Number(value).toFixed(2) : "";
